export type AccountID = string;
export type Amounts = Map<string, [number, number]>;


export function parseApiAmounts(apiAmounts: Record<string, any[]>): Amounts {
  return new Map(Object.entries(apiAmounts).map(
    ([currency, amount]) => [currency, amount as [number, number]]
  ));
}
